<template>
  <div class="content">
    <div class="content-left">
      <div class="content-left-top">
        <div style="cursor: pointer" @click="goBack"><img src="../../../assets/image/back.png"></div>
         <el-tooltip effect="light" :content="allPart.name" placement="top">
          <div style="font-size: 16px;" class="nowrap">{{allPart.name}}</div>
         </el-tooltip>
        <div style="width: 70%;text-align: right;">
          <span class="button" style="margin-right: 1vw;" @click="enterdata">参数设置</span>
          <span class="button" @click="handleDelete">删除</span>
        </div>
      </div>
      <div class="content-left-main">
        <div style="height: 200px;margin: 15px 0">
          <img src="../../../assets/image/sjj.png" style="heigh: 100%">
        </div>
        <div class="content-left-1">
          <div>
            <p style="margin-bottom: 10px;width: 4vw" class="nowrap">{{allPart.ratedWeight || 0}} T</p>
            <p style="font-size: 16px;">额定载荷</p>
          </div>
          <div>
            <p style="margin-bottom: 10px;width: 4vw" class="nowrap">{{floorNum || 0}} F</p>
            <p style="font-size: 16px;">最大楼层</p>
          </div>
          <div>
            <p style="margin-bottom: 10px;width: 4vw" class="nowrap">{{maxHeight || 0}} m</p>
            <p style="font-size: 16px;">最大高度</p>
          </div>
        </div>
        <div class="content-left-2">
          <div>是否超重：
            <span v-if="allPart.systemStatusWeight=='0'" style="color:#67C23A">正常</span>
            <span v-else-if="allPart.systemStatusWeight=='1'||allPart.systemStatusWeight=='2'" style="color:#F56C6C;">超载</span>
          </div>
          <div>当前楼层：{{allPart.floorNumber||'1'}}</div>
          <div>当前高度：</div>
          <div>当前速度：{{ allPart.speed }}m/s</div>
          <div>倾角度数：{{allPart.tilt||'0'}}°</div>
          <div>前门状态：{{allPart.foreDoorStatus=='0'?'开启':'关闭'}}</div>
          <div>后门状态：{{allPart.behindDoorStatus=='0'?'开启':'关闭'}}</div>
          <p style="font-size: 14px;color: #909399;">更新时间：{{allPart.updateDate}}</p>
        </div>
      </div>
    </div>
    <div class="content-right">
      <div class="content-right-top">
         <p class="title" style="display: flex;justify-content: space-between;align-items: center;width: 100%;font-size:16px;"><span>预警数据</span>
         <!-- <span class="button">更多</span> -->
         </p>
         <div style="height: 35vh;width: 66vw;" id="myChart"></div>
      </div>
      <div class="content-right-bottom">
        <div class="content-right-3">
          <p class="title" style="display: flex;justify-content: space-between;align-items: center;"><span style="font-size: 16px">预警记录</span><span class="button"  @click="toMore">更多</span></p>
          <div style="height: 38vh;padding: 18px 8px;overflow: auto">
            <div class="record-list" v-for="(item,index) in recordList" :key="index">
              <div style="display: flex;align-items: center;">
                <span style="display: inline-block;width:4vh;height:4vh;margin-right: 10px"><img :src="item.icon" style="max-width:4vh;max-height:4vh;"/></span>
                <span style="font-size: 14px">{{item.name}}</span>
              </div>
              <div style="font-size: 14px">{{item.val}} {{item.unit}}</div>
              <div style="font-size: 14px">{{item.createDate}}</div>
            </div>
          </div>
        </div>
        <div class="content-right-4">   
          <p class="title" style="display: flex;justify-content: space-between;align-items: center;"><span style="font-size: 16px">特种设备人员操作列表</span><span class="button" @click="enterrylb">更多</span></p>
          <div style="padding: 16px 8px">
            <el-table :data="tableData" border height="35vh" :header-cell-style="tableHeaderStyle">
              <el-table-column label="序号" type="index" :index="1" width="80"></el-table-column>
              <el-table-column
                  prop="name"
                  label="姓名">
              </el-table-column>
              <el-table-column
                  prop="certificateNumber"
                  label="证件编号">
              </el-table-column>
              <el-table-column
                  prop="certificatePhoto"
                  label="查看证书">
                  <template slot-scope="scope">
                      <el-image
                          v-if="scope.row.certificatePhoto!=''"
                          style="width: 6vh; height: 6vh;"
                          :src="scope.row.certificatePhoto"
                          :preview-src-list="scope.row.photoList"
                      ></el-image>
                      <div v-else class="no-photo" style="display: inline-block;">
                          <span style="display: block;">暂无</span>
                          <span style="display: block;">图片</span>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column label="操作记录" >
                  <template slot-scope="scope">
                      <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                          <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                      </div>
                  </template>
              </el-table-column>
              <!-- <el-table-column label="姓名">

              </el-table-column>
              <el-table-column label="证件编号">

              </el-table-column>
              <el-table-column label="证书">

              </el-table-column>
              <el-table-column label="操作记录">

              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        projectId: util.session.get('groupId'),
        id: '',
        deviceId: '',
        allPart: {}, 
        machType: '', 
        websocket: undefined,
        recordList: [],    // 记录
        tableData: [], 
        elevatorList: [],
        chartX:[],
        chartY:{},
        timeData: [],
        weightData: [],
        tileData: [],
        heightData: [],
        speedData: [],
        timer: undefined,
        tableTime:util.myTime.getCurTime(),
        floorNum: '',
        maxHeight: '',

      }
    },
    created() {
      const {id, deviceId} = this.$route.query
      this.id = id
      this.deviceId = deviceId
      this.getList()
      this.getRealInfo()
      this.initWebsocket()
      this.getHour()
    },
    mounted(){

    },
    methods: {
      goBack(){
        this.$router.go(-1)
      },
      initChart(){
        let chart = this.$echarts.init(document.querySelector('#myChart'))
        chart.setOption({
          color: ['#0D3A95', '#4D6EB1', '#145AE8', '#8397F0'],
          legend: {
            top: 0,
            right: 0,
            orient: 'vertical',
          },
          xAxis: {
            data: this.timeData
          },
          yAxis:{

          },
          series: [
            {
              type: 'bar',
              name: '重量',
              data: this.weightData,
              barWidth: 16,
              itemStyle: {
                borderRadius: [20,20,0,0],
              },
            },
            {
              type: 'bar',
              name: '倾角',
              data: this.tileData,
              barWidth: 16,
              itemStyle: {
                borderRadius: [20,20,0,0],
              }
            },
            {
              type: 'bar',
              name: '高度',
              data: this.heightData,
              barWidth: 16,
              itemStyle: {
                borderRadius: [20,20,0,0],
              }
            },
            {
              type: 'bar',
              name: '速度',
              data: this.speedData,
              barWidth: 16,
              itemStyle: {
                borderRadius: [20,20,0,0],
              }
            }
          ]
        })
      },
      // 获取塔吊信息
      getRealInfo(){
          var that = this
          myHttp.getEleInfoById({
              id:this.id
          }).then(function(resp){
            that.machType = resp.data.data.elevator.machType
            if(resp.data.code=='200'){
                var data = resp.data.data.elevator||{}
                if(data.baseSetting){
                  that.floorNum = JSON.parse(data.baseSetting).heightSettingBean.floorNum
                  that.maxHeight = parseFloat(that.floorNum) * parseFloat(JSON.parse(data.baseSetting).heightSettingBean.heightEachFloor)
                }
                data.weightReay = data.weight && data.weightPercent?(parseFloat(data.weight)/parseFloat(data.weightPercent)*100).toFixed(2):''
                data.speed = data.speed && data.speed!=''?parseFloat(data.speed).toFixed(2):0
                data.height = data.height && data.height!=''?parseFloat(data.height).toFixed(2):0
                data.tilt = data.tilt && data.tilt!=''?parseFloat(data.tilt).toFixed(1):0
                that.allPart = data
                that.weightData.push(data.weightReay)
                that.tileData.push(data.tilt)
                that.heightData.push(data.height)
                that.speedData.push(data.speed)
                that.timeData.push(util.myTime.formatTime('','HH:mm:ss'))
                that.initChart()
                for(var i in that.beatForm){
                    that.beatForm[i] = data[i]
                }
                if(that.timeData.length > 5){
                  that.timeData.shift()
                }
                if(that.weightData.length > 5){
                  that.weightData.shift()
                }
                if(that.tileData.length > 5){
                  that.tileData.shift()
                }
                if(that.heightData.length > 5){
                  that.heightData.shift()
                }
                if(that.speedData.length > 5){
                  that.speedData.shift()
                }
                that.timer = setTimeout(() => {
                  that.getRealInfo()
                },180000)
            }
          })
        },

       //获取24小时监测数据
        getHour(){
            var that = this
            this.recordList = []
            myHttp.latelyWarnInformation({
                projectId:this.projectId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    //高度预警
                    let list = []
                    var obj1 = data.latelyHeightWarn
                    if(obj1){
                        obj1.icon = require('../../../assets/image/icon/gd.png')
                        obj1.name = '高度预警'
                        obj1.val = parseFloat(obj1.height).toFixed(2)
                        obj1.unit = '米'
                        list.push(obj1)
                    }
                    //速度预警
                    var obj2 = data.latelySpeedWarn
                    if(obj2){
                        obj2.icon = require('../../../assets/image/icon/fs.png')
                        obj2.name = '速度预警'
                        obj2.val = parseFloat(obj2.speed).toFixed(2)
                        obj2.unit = '米每秒'
                        list.push(obj2)
                    }
                    //姿态预警
                    var obj3 = data.latelyTiltWarn
                    if(obj3){
                        obj3.icon = require('../../../assets/image/icon/qs.png')
                        obj3.name = '姿态预警'
                        obj3.val = parseFloat(obj3.tilt).toFixed(1)
                        obj3.unit = '度'
                        list.push(obj3)
                    }
                    //重量预警
                    var obj4 = data.latelyWeightWarn
                    if(obj4){
                        obj4.icon = require('../../../assets/image/icon/kg.png')
                        obj4.name = '重量预警'
                        obj4.val = parseFloat(obj4.weight).toFixed(2)
                        obj4.unit = '吨'
                        list.push(obj4)
                    }
                    that.recordList = list
                }
            })
            
        },

        //获取人员
        getPerson(){
            var that = this
            myHttp.getTzListByTeamsId({
                projectId:this.projectId,
                teamsId:this.getTeamId(this.deviceId),
                daysss:this.tableTime,
                status:'2',
                attendanceSn:this.getSn(this.deviceId)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.attendList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].certificatePhoto = list[i].certificatePhoto && list[i].certificatePhoto!=''?base.httpCtx+list[i].certificatePhoto:''
                        list[i].photoList = []
                        if(list[i].certificatePhoto!=''){
                            list[i].photoList.push(list[i].certificatePhoto)
                        }
                        list[i].photoFile = list[i].photoFile && ''!=list[i].photoFile?base.httpCtx+list[i].photoFile:''
                        if(list[i].photoFile!=''){
                            list[i].photoList.push(list[i].photoFile)
                        }
                        list[i].index = (i+1)
                    }
                    console.log(list);
                    that.tableData = list
                }
            })
        },
        //获取塔吊设备
        getList(){
          myHttp.getEleListByPage({
              projectId:this.projectId
          }).then(resp => {
              if(resp.data.code=='200'){
                  const list = resp.data.data.elevatorList||[]
                  this.elevatorList = list
                  if(list.length>0 && this.towerId==''){
                      this.towerId = list[0].id
                      this.deviceId = list[0].deviceId
                  }
                  this.getPerson()
              }
          })
        },


        //获取班组id
        getTeamId(id){
          console.log(id);
          let list = this.elevatorList
          var result = ''
          for(var i=0;i<list.length;i++){
              if(id==list[i].deviceId){
                  result = list[i].teamsId
              }
          }
          console.log(result);
          return result
        },

        //获取sn
        getSn(id){
          let list = this.elevatorList
          var result = ''
          for(var i=0;i<list.length;i++){
              if(id==list[i].deviceId){
                  result = list[i].attendanceSn
              }
          }
          return result
        },


         initWebsocket(){
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if(this.websocket && this.websocket!=''){
                this.websocket.close();
            }
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/webSocketEquip/"+this.projectId;//wss地址;
                }else{
                    url = base.httpWs+"/webSocketEquip/"+this.projectId;//ws地址;
                }
                // var url = base.httpWs+"/webSocketEquip/"+this.groupId;
                that.websocket = new WebSocket(url);
            }
            else{
                console.log('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){

            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
              console.log('------连接成功------');
                // that.errorFlag = false
                // that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                // console.log('==========deep1====websocket=================')
                console.log(x,'10086')
                if(x.flag=='8'){
                    that.refreshData(x.elevator)
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebsocket();
                }, 60000);
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket(){
            this.websocket.close();
        },

        //刷新数据
        refreshData(obj){
            if(obj.deviceId == this.deviceId){
                this.allPart.systemStatusWeight = obj.systemStatusWeight
                this.allPart.floorNumber = obj.floorNumber
                this.allPart.speed = obj.speed
                this.allPart.speedStatus = obj.speedStatus
                this.allPart.foreDoorStatus = obj.foreDoorStatus
                this.allPart.behindDoorStatus = obj.behindDoorStatus
                this.allPart.tilt = obj.tilt
                this.allPart.updateDate = util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss')
                if(this.chartX.length>4){
                    this.chartX.shift()
                    this.chartY.speed.shift()
                    this.chartY.height.shift()
                    this.chartY.floorNumber.shift()
                    this.chartX.push(util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss'))
                    this.chartY.speed.push(obj.speed)
                    this.chartY.height.push(obj.height)
                    this.chartY.floorNumber.push(obj.floorNumber)
                }else{
                    this.chartX.push(util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss'))
                    this.chartY.speed.push(obj.speed)
                    this.chartY.height.push(obj.height)
                    this.chartY.floorNumber.push(obj.floorNumber)
                }
            }
        },

         // 删除数据
          handleDelete() {
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                myHttp.delElevator({
                  id: that.deviceId
                }).then(function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.$router.go(-1)
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                })
            })
          },

        //查看更多
        toMore(){
          this.$router.push({path:'/eleWarn/'+this.deviceId})
        },

        enterrylb(){
          this.$router.push({path:'/elepageWarn1/'+this.deviceId})
        },

      // 表格头部样式
      tableHeaderStyle({row, column, rowIndex, columnIndex}){
        if(rowIndex == 0){
          return 'background: #ECF0F5'
        }
      },

      enterdata(){
        this.$router.push({
            path:'/eleProData',
            query:{
              id: this.deviceId
            }
        })
      },
    },
    beforeDestroy(){
      clearTimeout(this.timer)
      this.timer = null
      this.closeWebSocket()
    }
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 68px;
  height: 26px;
  line-height: 26px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}
.title{
  height: 60px;
  padding: 0 18px;
  line-height: 60px;
  text-align: left;
  border-bottom: 2px solid #E7E7E7;
  font-size: 18px;
}
.content{
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.content-left{
  width: 23%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 16px;
  overflow: auto;
}
.content-left-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 10px;
  border-bottom: 2px solid #E7E7E7;
}
.content-left-1{
  display: flex;
  justify-content: space-between;
  padding: 0 2vw;
  margin-bottom: 2vh;
}
.content-left-1 > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content-left-2 > div{
  width: 12vw;
  height: 46px;
  border-radius: 6px;
  font-size: 16px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin: 0 auto;
  margin-bottom: 17px;
  line-height: 46px;
  text-align: left;
  padding-left: 2vw;
}
.content-right{
  flex: 1;
}
.content-right-top{
  height: 42vh;
  width: 100%;
  margin-bottom: 1vh;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-right-1{
  width: 62%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-right-2{
  width: 36%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-right-bottom{
  display: flex;
  justify-content: space-between;
  height: 45vh;
}
.content-right-3{
  width: 49%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.record-list{
  height: 48px;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #D21B1B;
  padding: 0 16px;
}
.content-right-4{
  width: 49%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content >>> .cell{
  font-size: 14px;
}
.content >>> .el-table td.el-table__cell div{
  font-size: 14px;
}
</style>